export default function DriftKingIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#4a4f57" />
      <path d="M-4 52C14 50 26 40 30 26S48 6 70 6" stroke="#e53935" strokeWidth="6" strokeDasharray="6 6" fill="none" />
      <path d="M8 58c10-4 14-10 18-18" stroke="#1b1b1b" strokeWidth="4" strokeLinecap="round" opacity="0.7" fill="none" />
      <path d="M16 60c10-4 14-10 18-18" stroke="#1b1b1b" strokeWidth="4" strokeLinecap="round" opacity="0.7" fill="none" />
      <circle cx="14" cy="50" r="7" fill="#e8e8e8" opacity="0.75" />
      <circle cx="22" cy="56" r="6" fill="#e8e8e8" opacity="0.6" />
      <g transform="translate(38 30) rotate(-55)">
        <rect x="-15" y="-8" width="30" height="16" rx="5" fill="#ff3b5c" />
        <rect x="-5" y="-6" width="11" height="12" rx="3" fill="#1d2733" />
        <rect x="-17" y="-7" width="3" height="14" fill="#222" />
        <rect x="13" y="-7" width="2" height="4" fill="#fff8c4" />
        <rect x="13" y="3" width="2" height="4" fill="#fff8c4" />
      </g>
    </svg>
  );
}
